export default {
  title: 'Während Ihrer Bearbeitung geändert',
  descriptionConflicts: 'Diese Daten wurden zwischenzeitlich gespeichert. Klicken Sie für jedes Feld, das Sie ebenfalls geändert haben, auf den Wert, der übernommen werden soll.',
  descriptionServerChanges: 'Diese Daten wurden zwischenzeitlich gespeichert. Diese Änderungen werden zusammen mit Ihren übernommen. Machen Sie die rückgängig, die Sie nicht übernehmen möchten.',
  notSaved: 'Nicht gespeichert',
  field: 'Feld',
  keepAll: 'Alle Werte übernehmen',
  keeping: 'Wird übernommen',
  you: 'Sie',
  combined: 'Beide übernehmen (Serverversion zuerst)',
  added: 'Hinzugefügt',
  removed: 'Entfernt',
  missing: 'Nicht vorhanden',
  value: 'Wert',
  positionStart: 'Zu Beginn',
  positionAfter: 'Nach {item}',
  resolvedCount: '{resolved} von {total} Konflikt gelöst | {resolved} von {total} Konflikten gelöst',
  saveDisabled: 'Wählen Sie noch für {count} Feld einen Wert | Wählen Sie noch für {count} Felder einen Wert',
  serverChanges: 'Änderungen der Serverversion ohne Konflikt: {count}',
  show: 'Änderungen anzeigen',
  hide: 'Änderungen ausblenden',
  revert: 'Änderung rückgängig machen',
  restore: 'Änderung wiederherstellen',
  reverted: 'Ihr Wert bleibt erhalten',
  cancelTooltip: 'Ihre Änderungen verwerfen und die Serverversion weiterbearbeiten',
  latestMissing: 'Diese Daten wurden während Ihrer Bearbeitung auf dem Server gelöscht. Ihre Änderungen können nicht gespeichert werden.',
  version: {
    original: 'Ursprüngliche Version',
    latest: 'Serverversion',
    edited: 'Ihre Version',
  },
};
